//
import BankModel from "@/models/General/GBank"

//
export default [
    {
        name: "serial_number",
        type: "text-field",
        props: {            
            label: "Numero de serie",
        },
    },
    {
        name: "g_bank_id",
        type: "autocomplete-model",
        props: {
            itemText: "bank",
            itemValue: "id",
            label: "Banco",
            model: BankModel,
            noObject: true,
            paramSearch: "bank",
        },
    },
]